// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M17 4h-3V2c0-1.103-.897-2-2-2H8C6.897 0 6 .897 6 2v2H3a1 1 0 100 2v13a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 100-2zM5 18h10V6H5v12zM8 4h4V2H8v2zm0 12a1 1 0 001-1V9a1 1 0 10-2 0v6a1 1 0 001 1m4 0a1 1 0 001-1V9a1 1 0 10-2 0v6a1 1 0 001 1\"/></svg>";
// Exports
module.exports = code;